import React, {Component} from 'react'
import Header from 'components/Header';

class NotFound extends Component{
    render(){
        return (
            <section id="main">
                <section id="la-soundbox-container" className={'home'}>
                    <Header/>
                    <div className={'not-found'}>Page not found</div>
                </section>
            </section>
        )
    }
}

export default NotFound
